import { Provider } from 'react-redux'
import { sharedStore } from '@Techedge/digitalportal-shared'
import AppRouter from './routing/app-router'

export default function Root(props) {
    return (
        <Provider store={sharedStore}>
            <AppRouter {...props} />
        </Provider>
    )
}
